function query<T extends HTMLElement = HTMLDivElement>(selector: string) {
  return document.querySelector(selector) as T;
}

export class StripeUI {
  public title = query('#product-title-element');
  public price = query('#product-price-element');
  public info = query('#product-info-element');
  public payment = query('#payment-element');
  public container = query('#stripe-container');
  public submit = query<HTMLButtonElement>('#submit');
  public close = query<HTMLButtonElement>('#payment-close-button');
  public form = query<HTMLFormElement>('#stripe-payment-form');
  public bg = query('#stripe-bg');
  public spinner = query('#spinner');
  public buttonText = query('#button-text');
  public message = document.querySelector('#payment-message');

  public show(title: string, price: string) {
    this.title.textContent = title;
    this.price.textContent = price;
    this.setLoading(false);
    this.container.classList.remove('hidden');
    this.bg.classList.remove('hidden');
    this.form.classList.remove('hidden');
  }

  public hide() {
    this.setLoading(false);
    this.container.classList.add('hidden');
    this.bg.classList.add('hidden');
    this.form.classList.add('hidden');
  }

  public setLoading(isLoading: boolean) {
    if (isLoading) {
      // Disable buttons and show a spinner
      this.submit.disabled = true;
      this.close.disabled = true;
      this.spinner.classList.remove('hidden');
      this.buttonText.classList.add('hidden');
    } else {
      this.submit.disabled = false;
      this.close.disabled = false;
      this.spinner.classList.add('hidden');
      this.buttonText.classList.remove('hidden');
    }
  }

  public onSubmit(fn: () => unknown) {
    this.form.onsubmit = (event) => {
      event.preventDefault();
      this.setLoading(true);
      fn();
    };
  }

  public onClose(fn: () => unknown) {
    this.close.onclick = () => {
      this.hide();
      fn();
    };
  }

  public showMessage(messageText: string, callback?: () => void) {
    this.message.classList.remove('hidden');
    this.message.textContent = messageText;
    this.form.scrollTop = this.form.scrollHeight;
    setTimeout(() => {
      this.message.classList.add('hidden');
      this.message.textContent = '';
      callback?.();
    }, 5000);
  }
}
